const MAP = {
  Open: "bg-slate-100 text-slate-600 border-slate-300",
  Interested: "bg-purple-100 text-purple-800 border-purple-300",
  Requested: "bg-blue-100 text-blue-700 border-blue-300 animate-pulse",
  Confirmed: "bg-emerald-100 text-emerald-700 border-emerald-300",
  Completed: "bg-slate-100 text-slate-500 border-slate-300",
  Cancelled: "bg-red-100 text-red-700 border-red-300",
};

export const StatusPill = ({ status, testId }) => (
  <span className={`pill ${MAP[status] || MAP.Open}`} data-testid={testId || `status-${String(status).toLowerCase()}`}>
    {status}
  </span>
);

export const MatchBadge = ({ score, testId }) => {
  const tone =
    score >= 85 ? "bg-emerald-50 text-emerald-700 border-emerald-200" :
    score >= 70 ? "bg-blue-50 text-brand border-blue-200" :
    "bg-slate-50 text-slate-600 border-slate-200";
  return (
    <span className={`pill font-display text-sm font-semibold ${tone}`} data-testid={testId || "match-badge"}>
      {score}% Match
    </span>
  );
};

export const UrgentPill = ({ testId }) => (
  <span className="pill animate-pulse border-orange-300 bg-accentx-soft text-accentx-hover" data-testid={testId || "urgent-pill"}>
    Urgent coverage
  </span>
);

export const ReliabilityBadge = ({ reliability, testId }) => {
  if (!reliability || reliability.reliability_score == null)
    return (
      <span className="pill border-slate-200 bg-slate-50 text-slate-500" data-testid={testId || "reliability-badge"}>
        New worker
      </span>
    );
  const { reliability_score, avg_rating, completed_shifts } = reliability;
  const tone =
    reliability_score >= 85 ? "border-emerald-200 bg-emerald-50 text-emerald-700"
      : reliability_score >= 65 ? "border-blue-200 bg-blue-50 text-brand"
      : "border-orange-200 bg-orange-50 text-accentx-hover";
  return (
    <span className={`pill ${tone}`} data-testid={testId || "reliability-badge"}>
      {reliability_score}% reliable
      {avg_rating != null && ` · ${avg_rating}★`}
      {` · ${completed_shifts} done`}
    </span>
  );
};

export const RepeatPill = ({ count, testId }) =>
  count > 0 ? (
    <span className="pill border-brand/30 bg-brand-soft text-brand" data-testid={testId || "repeat-pill"}>
      Worked here {count}×
    </span>
  ) : null;
